import { render, staticRenderFns } from "./CommunicationCard.vue?vue&type=template&id=71dfbb3c"
import script from "./CommunicationCard.vue?vue&type=script&lang=js"
export * from "./CommunicationCard.vue?vue&type=script&lang=js"
import style0 from "./CommunicationCard.vue?vue&type=style&index=0&id=71dfbb3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports